import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=4fc16ee8&scoped=true&"
import script from "./SimpleHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=4fc16ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc16ee8",
  null
  
)

export default component.exports